export const INPUT_COLOR_VARIANT_DEFAULT = 'default'
export const INPUT_COLOR_VARIANT_DANGER = 'danger'

export const INPUT_COLOR_PICKER_HEX = 'hex'
export const INPUT_COLOR_PICKER_HEXALPHA = 'hexalpha'
